import { Select,Form } from 'antd'
import { projectType } from './projectType'
function ProjectTypeSelect(props) {
    return (
        <Form.Item 
            label={props.label} 
            wrapperCol={props.wrapperCol} 
            required={props.required} 
            name={props.name}      
            initialValue={props.initialValue}  
        >
            <Select 
                options={projectType} 
                onChange={(_,f) => {
                    // console.log(f);
                    props.onChange(f.value,f.label)
                }}
                style={props.style}
                disabled={props.disabled}
                placeholder={props.placeholder}
            />
        </Form.Item>
)
}

export default ProjectTypeSelect